"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHomepartLastTime = void 0;
var React = __importStar(require("react"));
var IconHomepartLastTime = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("path", { fill: "#464650", d: "M12.1363337,2 C11.8640564,2 11.6432644,2.224 11.6432644,2.5 C11.6432644,2.776 11.8640564,3 12.1363337,3 C17.0313832,3 21.0135614,7.037 21.0135614,12 C21.0135614,16.963 17.0313832,21 12.1363337,21 C7.24128416,21 3.25910594,16.963 3.25910594,12 C3.25910594,10.276 3.75712574,8.595 4.66504653,7.155 L6.46603663,8.011 L5.90663069,3.328 L1.9997,5.889 L3.76504653,6.728 C2.8006901,8.303 2.27296733,10.129 2.27296733,12 C2.27296733,17.514 6.6967297,22 12.1363337,22 C17.5749475,22 21.9997,17.514 21.9997,12 C21.9997,6.486 17.5749475,2 12.1363337,2" }),
        React.createElement("path", { fill: "#464650", d: "M9.5243,17.9473 C9.5953,17.9833 9.6713,18.0003 9.7463,18.0003 C9.9293,18.0003 10.1053,17.8983 10.1923,17.7233 L12.5773,12.9363 L16.8283,11.9883 C17.0973,11.9273 17.2663,11.6613 17.2073,11.3913 C17.1473,11.1223 16.8793,10.9563 16.6123,11.0113 L11.8983,12.0633 L9.3013,17.2763 C9.1783,17.5233 9.2783,17.8233 9.5243,17.9473" })))); };
exports.IconHomepartLastTime = IconHomepartLastTime;
exports.IconHomepartLastTime.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHomepartLastTime;
